module.exports = __webpack_public_path__ + "static/media/rating_1.ecaeafe0.svg";